<template>
  <div
    v-if="localValue.type === 'dropdown'"
    :id="'localValue' + index"
    :style="
      'margin: ' + styles.margin.join('px ') + 'px;' +
      'color:' + styles.color + ';'
    "
  >
    <div
      class="text-sm font-semibold mb-2"
      :style="
        'text-align: ' + styles.text.textAlign + ';' +
        'color: ' + styles.labelColor + ';'
      "
      v-if="!hideLabels"
    >
      {{ localValue.label }}
      <span
        v-if="
        localValue.mandatory === true ||
        localValue.mandatory === 1 ||
        localValue.mandatory === 'true'
        "
        style="color: red; font-weight: bold"
        >*</span
      >
    </div>
    <select
      class="rounded w-full focus:outline-none text-sm rounded bg-white"
      :style="
        'background:' + styles.backgroundColor + ';' +
        'box-shadow:' + (styles.boxShadow ?? '') + ';' +
        'padding: ' + styles.padding.join('px ') + 'px;' +

        '--form-style-placeholder-color:' + styles.placeholderColor + ';' +
        'font-family:' + (styles.text.fontFamily || '') + ';' +
        'text-shadow:' + (styles.text.textShadow || '') + ';' +
        'font-size:' + styles.text.fontSize + 'px;' +
        'text-align:' + styles.text.textAlign + ';' +
        'font-style:' + (styles.text.fontStyle || '') + ';' +
        'font-weight:' + (styles.text.fontWeight || '') + ';' +
        'letter-spacing:' + (styles.text.letterSpacing || '') + ';' +
        'line-height:' + (styles.text.lineHeight || '') + ';' +
        '-webkit-text-stroke-width:' + (styles.text.textStrokeWidth || '') + ';' +
        '-webkit-text-stroke-color:' + (styles.text.textStrokeColor || '') + ';' +
        'text-decoration-line:' + (styles.text.textDecorationLine || '') + ';' +
        'color:' + styles.text.color + ';' +

        'border-width:' + styles.border?.width.join('px ') + 'px;' +
        'border-radius:' + styles.border?.radius.join('px ') + 'px;' +
        'border-color:' + styles.border?.color.join(' ') + ';' +
        'border-style:' + styles.border?.style.join(' ') + ';' +
        styles.customStyles ?? ''
      "
    >
      <option
        disabled
        v-if="hideLabels"
        selected
      >{{localValue.label}}</option>

      <option
        v-for="(option, index) in localValue.options"
        :key="index"
      >
        {{ option }}
      </option>
    </select>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'FormDropdown',
  props: {
    value: {
      required: true,
    },
    index: {
      required: true,
    },
    styles: {
      required: true,
    },
  },
  computed: {
    ...mapState({
      hideLabels: state => state.forms.hideLabels,
    }),
    localValue: {
      get: function () {
        return this.value;
      },
      set: function (val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    hide() {
      this.localValue = '';
      this.localShown = false;
    },
    onTextChange(e) {
      console.log(e.target.innerText);
      this.localValue = e.target.innerText;
    },
  }
}
</script>
